module.exports = __webpack_public_path__ + "static/media/beh_2_Master.a462b5b2.wav";